module.exports = JSON.parse('{"Measurements":"Metingen","Studies":"Studieën"}')